import { BASE_V2_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'LEARNOSITY_TAGS_GET',
  GET_SUCCESS: 'LEARNOSITY_TAGS_GET_SUCCESS',
  GET_FAILURE: 'LEARNOSITY_TAGS_GET_FAILURE',
};

export const get = actions.get(
  learnosityActivityReference =>
    `${BASE_V2_URL}/learnosity-activity-tags/?learnosity_reference=${learnosityActivityReference}`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
